export default "__VITE_ASSET__5264cdda__"